import { KYMW7200Model } from '../kymw7200.model';
import { Injectable } from "@angular/core";
import { PlessHttp } from '../../../../shared/http/pless-http.service';
import { PlessDialogServiceSub } from '../../../../commons/kymw00/pless-dialog-service-sub';
import { PlessJsonResponderSub } from 'src/app/commons/kymw00/pless-json-responder-sub.service';
import { PlessRequest } from 'src/app/shared/vo/pless-request.model';

/**
 * 運営商品一覧情報削除
 *
 * @export 
 * @class DeleteOperationGoodsService
 * @extends {PlessJsonResponderSub}
 */
@Injectable()
export class DeleteOperationGoodsService extends PlessJsonResponderSub<any> {
  // 処理に使用するModel
  public operationGoodsIds: string[];
  private successFunc: Function;

  constructor(
    protected plessHttp: PlessHttp,
    protected dialogService: PlessDialogServiceSub
  ) {
    super(plessHttp, dialogService);
  }

  /**
   * bodyにセットする値を返す
   *
   * @private
   * @returns {PlessRequest} リクエストJSON
   * @memberof 
   */
  private getBody(): PlessRequest {
    return new PlessRequest({
      delete: {
        DeleteOperationGoods: {
          combination: this.operationGoodsIds.map(operationGoodsId => {
            return {
              parameter: {
                OperationGoodsId: operationGoodsId
              }
            }
          })
        },
      }
    });
  }

  /**
    * API呼び出し
    *
    * @param model
    * @memberof DeleteOperationGoodsService
    */
  execute(operationGoodsIds: string[], successFunc: Function = null): void {
    this.operationGoodsIds = operationGoodsIds;
    this.successFunc = successFunc;
    this.send('deleteOperationGoods', this.getBody());
  }

  /**
   * API通信成功時の処理
   *
   * @param {*} data レスポンスデータ
   * @memberof DeleteOperationGoodsService
   */
  success(data: any): void {
    if (this.successFunc !== null) {
      this.successFunc();
    }
  }

  /**
     * 業務エラー時のメソッド
     * @param errList サーバ受信データ
     * 機能独自の処理を行う場合、このメソッドをオーバーライドして処理を実装する。
     */
  public plessErrorHandler(errList: Object): void {
    super.plessErrorHandler(errList);
  }

  /**
   * 特殊なエラーが返ってきた場合に呼び出されるメソッド。<br/>
   * 機能独自のステータスコードを持つ場合、このメソッドをオーバーライドして処理を実装する。
   */
  public exceptionError(status: string, result: any): void {
    super.exceptionError(status, result);
  }
}
